var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-button',_vm._b({class:[_vm.$style.button, _vm.$style[_vm.color]],attrs:{"label":_vm.label,"disabled":_vm.disabled},nativeOn:{"click":function($event){return _vm.handler.apply(null, arguments)}}},'m-button',_vm.props,false))}
var staticRenderFns = []

export { render, staticRenderFns }